import dataReducers from "./PreReservationButtonReducer";

const dataReducer = {
    reducers: dataReducers
}

export default dataReducer;